module.exports = __webpack_public_path__ + "static/img/9.6fb8563.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/9.png
// module id = ReaE
// module chunks = 0